import { Form } from 'formik';
import styled from 'styled-components';

export const RatingContactFollowUpForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl};
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing['2Xl']};
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SubmitSection = styled.div`
  display: flex;
  justify-content: space-between;
`;
